import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiCheckCircle, HiOfficeBuilding, HiClock, HiPhone, HiMail, HiArrowLeft } from 'react-icons/hi';

const RegistrationSuccess = () => {
  const location = useLocation();
  const fullname = location.state?.fullname || 'User';
  const company_name = location.state?.companyName || 'Your Company';

  // Dark mode state
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains('dark-mode'));
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  // Confetti effect inside the card header
  const confetti = (
    <div className="registration-success-confetti">
      {[...Array(30)].map((_, i) => (
        <div
          key={i}
          className="registration-success-confetti-dot"
          style={{
            position: 'absolute',
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 60}px`,
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: `hsl(${Math.random() * 360}, 80%, 60%)`,
            opacity: 0.7,
            animation: `fall 1.5s ${Math.random()}s ease-in-out infinite`,
          }}
        />
      ))}
    </div>
  );

  return (
    <div className="registration-success-root">
      <div className="registration-success-card">
       
        <div className="registration-success-header">
          {confetti}
          <div className="registration-success-header-icon">
            <HiCheckCircle style={{ width: 56, height: 56, color: 'white', filter: 'drop-shadow(0 2px 8px #059669)' }} />
          </div>
          <h1 className="registration-success-header-title">
            Registration Successful!
          </h1>
          <p className="registration-success-header-welcome">
            Welcome to ZipAccounts
          </p>
        </div>
        {/* Card Content */}
        <div className="registration-success-content">
          <div className="registration-success-company">
            <h2 className="registration-success-company-title">
              {company_name} is now registered!
            </h2>
            <p className="registration-success-company-greeting">
              Dear <span style={{ fontWeight: 700, color: isDarkMode ? '#fff' : '#22223b' }}>{fullname}</span>,
            </p>
          </div>
          <div className="registration-success-card-info">
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <HiOfficeBuilding style={{ width: 28, height: 28, color: isDarkMode ? '#38bdf8' : '#2563eb', marginTop: 2, flexShrink: 0 }} />
              <div>
                <p>
                  Thank you for registering your agency with <span style={{ fontWeight: 600, color: isDarkMode ? '#38bdf8' : '#2563eb' }}>ZipAccounts</span>. Your agency <span style={{ fontWeight: 600 }}>{company_name}</span> has been successfully registered with our platform.
                </p>
              </div>
            </div>
          </div>
          <div className="registration-success-card-next">
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <HiClock style={{ width: 28, height: 28, color: isDarkMode ? '#fde68a' : '#f59e42', marginTop: 2, flexShrink: 0 }} />
              <div>
                <h3>What's Next?</h3>
                <p>
                  Our representative will contact you shortly to proceed with the activation of your account. If you don't receive an email within 48 hours, please feel free to reach out to us.
                </p>
              </div>
            </div>
          </div>
          <div className="registration-success-card-office">
            <h3>Visit Our Office</h3>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 10 }}>
              <HiOfficeBuilding style={{ width: 22, height: 22, color: isDarkMode ? '#38bdf8' : '#64748b', marginTop: 2, flexShrink: 0 }} />
              <div>
                <p className="office-title">Nexagen Solution</p>
                <p className="office-address">Ali Mall, 2nd Floor, Susan Road, Faisalabad, Pakistan</p>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
              <HiPhone style={{ width: 22, height: 22, color: isDarkMode ? '#38bdf8' : '#64748b', flexShrink: 0 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                <a href="tel:+923156666402" className="office-phone">+92 315 666 6402</a>
                <span className="office-separator">|</span>
                <a href="tel:+923037682000" className="office-phone">+92 303 7682000</a>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <HiMail style={{ width: 22, height: 22, color: isDarkMode ? '#38bdf8' : '#64748b', flexShrink: 0 }} />
              <a href="mailto:info@nexagensolution.com" className="office-email">info@nexagensolution.com</a>
            </div>
          </div>
          <div className="registration-success-footer">
            <p>Best Regards,</p>
            <p className="footer-team">Nexagen Solution Support Team</p>
          </div>
          <Link
            to="/"
            className="registration-success-home-link"
          >
            <HiArrowLeft style={{ width: 22, height: 22 }} />
            <span>Return to Home</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess; 